export default __webpack_public_path__ + "static/media/nothing_found_icon.ee647954.svg";